/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";
// @mui material components

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 PRO React examples
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
import grapesjs from "grapesjs";
// import GjsEditor from "@grapesjs/react";
import customCodePlugin from "layouts/pages/utils/custom-code-grapejs/index.ts";
// import sendpadForm from "layouts/pages/utils/sendpadForm/index.ts";
import gjsTabs from "layouts/pages/utils/grapeJsTabs/index";
import gjsImageEditor from "layouts/pages/utils/grapeJsImageEditor/index.ts";
import gjsTooltip from "grapesjs-tooltip";
import gjsp from "grapesjs-preset-webpage";
import gjsModal from "layouts/pages/utils/grapejsModal/index.ts";
import gjsAccordian from "grapesjs-accordion";
import alignment from "layouts/pages/customstyles/alignment.js";
import placeholder from "layouts/pages/utils/grapesJSPlaceholder/index.js";
import { utils } from "../pages/utils/index";
import { updateBlocks } from "../pages/blocks/updateblocks";
import { newBlocks } from "../pages/blocks/newblocks";
import { sidebarPannel } from "../pages/panels/sidebarpanel";
import { grapeJsEvents } from "../pages/events/grapeJsEvents";
import { ExpandText } from "../pages/components/expandText";
import { ImageAI } from "../pages/components/imageAI";
import { SendPadForm } from "../pages/components/sendPadForm.js";
import myNewComponentTypes from "../pages/components/grapejscomponents/index.ts";
import { NextPageButton } from "../pages/components/nextPageButton";

import client from "ApiClient";
import { CircularProgress, Dialog, DialogContent, DialogActions } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Settingsidebar from "layouts/pages/panels/settingsidebar";
import MDSnackbar from "components/MDSnackbar";
import ConfirmationAlert from "components/ConfirmationAlert";
import SimpleReactValidator from "simple-react-validator";
import tiny_mce from "layouts/pages/tiny_mce";
import Templates from "../funnels/components/templates";
import replaceTextViewComponent from "layouts/pages/utils/single-click-tinymce";
import { useSearchParams } from "react-router-dom";

function Grape() {
  const [isLoading, setIsLoading] = useState(false);
  const [openSettingSaved, setOpenSettingSaved] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [openConfirmationClose, setOpenConfirmationClose] = useState(false);
  const [savingOpen, setSavingOpen] = useState(false);
  const closeSettingSaved = () => setOpenSettingSaved(false);
  const [settingSidebarOpen, setSettingSidebarOpen] = useState(false);
  const [grapeEditor, setGrapeEditor] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [loadingText, setLoadingText] = useState("Loading ...");

  const [pageTitle, setPageTitle] = useState("");
  const [faviconUrl, setFaviconUrl] = useState("");
  const [bgImageUrl, setBgImageUrl] = useState("");
  const [pagKeywords, setPagKeywords] = useState("");
  const [pagSlug, setPagSlug] = useState("");
  const [pagDescription, setPagDescription] = useState("");
  const [pagGoogleConversionID, setPagGoogleConversionID] = useState("");
  const [pagGoogleConversionLabel, setPagGoogleConversionLabel] = useState("");
  const [pagGoogleMetaTag, setPagGoogleMetaTag] = useState("");
  const [pagGoogleAnalyticsID, setPagGoogleAnalyticsID] = useState("");
  const [pagMSVerificationTag, setPagMSVerificationTag] = useState("");
  const [pagMSUETTagID, setPagMSUETTagID] = useState("");
  const [pagCustomHead, setPagCustomHead] = useState("");
  const [pagCustomBody, setPagCustomBody] = useState("");
  const [pagCustomFooter, setPagCustomFooter] = useState("");
  const [sendpadForms, setSendpadForms] = useState([]);

  const [openTemplates, setOpenTemplates] = useState(false);
  const [openPageTitle, setOpenPageTitle] = useState(false);

  const [draftLoading, setDraftLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator());

  const [images] = useState([]);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const options = {
    method: "GET",
    url: "pages",
    headers: {
      "content-type": "application/json",
    },
  };

  const save = async () => {
    setIsSaving(true);
    setLoadingText("");
    options.method = "PUT";
    options.url = `pages/chancho`;

    // const data = grapeEditor.getProjectData();
    //const html = grapeEditor.Commands.run("gjs-get-inlined-html"); // grapeEditor.getHtml();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();

    const newPage = selectedPage;
    newPage.pag_html = html;
    newPage.pag_css = css;

    options.data = JSON.stringify(newPage);

    client
      .request(options)
      .then((response) => {
        setSelectedPage(response);
        setIsSaving(false);
        setSavingOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    initEditor();
  }, []);

  useEffect(() => {
    console.log("grapeEditor", grapeEditor);
    if (grapeEditor) save();
  }, [grapeEditor]);

  const initEditor = () => {
    setIsLoading(true);
    const plugins = [
      gjsAccordian,
      gjsImageEditor,
      gjsp,
      gjsTabs,
      gjsTooltip,
      //  ImageAI,
      //  ExpandText,
      gjsModal,
      alignment,
      tiny_mce,
      customCodePlugin,
      NextPageButton,
      placeholder,
      myNewComponentTypes,
    ];

    const editor = grapesjs.init({
      allowScripts: 1,
      storageManager: false,
      container: "#gjs",
      height: "100vh",
      fromElement: true,
      styleManager: {
        sectors: [
          {
            name: "Dimension",
            open: false,
            properties: ["width", "height", "max-width", "min-height", "margin", "padding"],
          },
          {
            name: "Flex",
            open: false,
            properties: [
              "flex-direction",
              "flex-wrap",
              "justify-content",
              "align-items",
              "align-content",
              "order",
              "flex-basis",
              "flex-grow",
              "flex-shrink",
              "align-self",
            ],
          },
          {
            name: "Alignment",
            properties: [
              {
                type: "my-custom-prop",
                property: "text-align",
                default: "center",
              },
            ],
          },
        ],
      },
      canvasCss: `
          gjs-plh-image{
              color:#3b97e3;
          }
          .image-pl-svg{
              fill:#3b97e3;
          }
          .gjs-plh-image[data-gjs-type="image"]{
              width:30%;
              height:30%;
              background-color:transparent;
              outline:none;
  
          }
        
          div.navbar[data-gjs="navbar"]{
              max-width:100%;
  
          }
          div.navbar[data-gjs="navbar"]>.navbar-container{
              max-width:1140px;
          }
         
  
          .gjs-selected{
              outline: 4px solid #3b97e3 !important;
              outline-offset: -2px;
          }
          img.gjs-selected{
              z-index: 90000001;
              position: relative;
          }
          .gjs-higlight-backdrop-container{
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #151515;
              z-index:9000000;
              opacity:0;
              transition: opacity 0.3s ease-in
          }
          .gjs-higlight-backdrop-container.active{
              opacity:0.3;
          }
  
          .form-group {
              width: 100%;
          }
  
          .form-group {
              width: 100%;
          }
          [data-gjs-type="grid-item"]:empty {
              overflow: hidden;
              text-decoration: none;
              padding: 5px;
              display: flow;
      width: 99%;
          }
          .cell{
            height: auto !important;
          }
          [data-gjs-type="grid-item"]:empty:before {
              background-color: #ddd;
              color: #000;
              font-size: 16px;
              font-weight: bold;
              height: 75px;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 50px;
              padding: 0 10px;
              opacity: 0.3;
              border-radius: 3px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              content: "Column";
          }   
          .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
  
        `,
      protectedCss: `body{margin:0; }.row{margin:0 auto;box-sizing:border-box;} div.row>div.cell:first-child{
              padding-right:6px;
              padding-left:0px;
          }div.row>div.cell:last-child{
              padding-left:6px;
              padding-right:0px;
          }div.cell{
              padding-left:3px;
              padding-right:3px;
          } 
          .cell{
            height: auto !important;
          }
          .right-space-issue {
    margin-right: 3rem;
  } @media (max-width: 768px){       .right-space-issue {
    margin-right: 0;
  }}
          .openModalBtn{border: none; cursor: pointer; background-color: #f0c864; color: #000;font-weight: 700; line-height: 1.66; font-size: 20px; border: 0; border-radius: 30px; display: inline-block; padding: 8px 20px; width: auto; height: 48px;} .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;} a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}img{max-width:100%;height:auto}.cell {height: auto;vertical-align: top;}.cke_editable p{display: block; margin-block-start: 0em !important; margin-block-end: 0em !important;margin-inline-start: 0em !important;margin-inline-end: 0em !important;}table.grid-item-card tbody tr td {background: none !important;}.list-item tr td {background: none !important;}.form-group{ float:none; flex-direction:column; border:0 solid black; display:flex; } .label{ margin:0 0 15px 0; font-family:Arial, Helvetica, sans-serif; font-size:14px; font-weight:600; } .form{ display:flex; flex-direction:column; padding:50px 50px 50px 50px; border:1px solid #6c7978; margin:10px 10px 10px 10px; background-color:#f5f5f5; } .input{ height:40px; width:auto; margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px; } textarea { margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px;} .button{ height:42px; border-radius:7px; margin:10px 0 0 0; border:1px solid #7e7e7e; font-family:Arial Black, Gadget, sans-serif; font-size:14px; font-weight:600; color:#ffffff; background-color:#000000; } .form-group:nth-child(3) {display: none;} .form-group:nth-child(4) {display: none;}.form-group:has(> .checkbox) { flex-direction:row;align-items: start; }input.checkbox {margin-left: 25px;}label.checkbox-label {margin-left: 5px;} @media (max-width: 992px){ .form{ padding:20px 20px 20px 20px; } }@media (max-width:768px){.cell{width:100%;}div.row>div.cell:first-child{
              padding-right:0px;
              padding-left:0px;
          }div.row>div.cell:last-child{
              padding-left:0px;
              padding-right:0px;
          } }
          .form-group {
              width: 100%;
          }
          .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
        .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;}a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}.row{padding:0 !important;}p{padding:0 !important; margin:0 !important;}h1{padding:0 !important; margin:0 !important;}h4{padding:0; margin:0;}@media(max-width:768px){.cell{display: block !important; width: 100% !important; height: auto !important; padding: 0 !important; min-height: 75px !important; }}.accordion>p{display:inline-block;}           
         `,
      width: "100%",
      plugins: plugins,
      pluginsOpts: {
        [gjsp]: {
          blocks: [],
          showStylesOnChange: false,
          // options
        },
        customCodePlugin: {
          placeholderScript: true,
          blockCustomCode: { label: "Custom" },
          // options
        },
        [tiny_mce]: {
          "tinymce-module": "/tinymce/tinymce.min.js",
          inline: ["span", "a", "button"],
          inline_toolbar: [
            "bold italic underline strikethrough forecolor backcolor",
            "fontfamily fontsize",
          ],
          toolbar: [
            "bold italic underline strikethrough link fontfamily fontsize outdent indent",
            "blocks forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist",
          ],
          plugins: ["link", "lists", "autolink"],
        },
        [placeholder]: {
          dragDefault: [""],
          dragClasses: ["gjs-selected", "gjs-freezed", "animation"],
          animation: ["none"], // animation1 / animation2 / animation3 / animation4 / animation5 / none
        },
      },
      clearOnRender: true,

      deviceManager: {
        devices: [
          {
            id: "desktop",
            name: "Desktop",
            width: "",
          },
          {
            id: "tablet",
            name: "Tablet",
            width: "768px",
            widthMedia: "992px",
          },
          {
            id: "mobilePortrait",
            name: "Mobile portrait",
            title: "Mobile portrait",
            width: "320px",
            widthMedia: "575px",
          },
        ],
      },
    });

    editor.on("load", () => {
      updateBlocks(editor);

      options.method = "GET";
      options.url = `pages/byid?page_id=${id}`;
      client
        .request(options)
        .then((response) => {
          setSelectedPage(response);
          editor.setComponents(remoteData["gjs-components"]);
          editor.loadProjectData(JSON.parse(response.pag_json));
          editor.UndoManager.clear();
          setGrapeEditor(editor);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    });

    editor.on("asset:remove", (asset) => {
      deleteImages(asset.attributes);
    });

    newBlocks(editor);

    const panelManager = editor.Panels;

    editor.Panels.removeButton("options", "undo");
    editor.Panels.removeButton("options", "redo");
    panelManager.addButton("options", [
      {
        id: "undo",
        className: "fa fa-undo icon-undo",
        command: function (editor, sender) {
          //console.log("sender", sender);
          if (editor.UndoManager.hasUndo()) {
            editor.UndoManager.undo();
            //sender.set("active", 0);
          }
        },
        attributes: {
          title: "Undo (CTRL/CMD + Z)",
        },
      },
      {
        id: "redo",
        className: "fa fa-repeat icon-redo",
        command: function (editor, sender) {
          //console.log("hasRedo", editor.UndoManager.hasRedo());
          if (editor.UndoManager.hasRedo()) {
            editor.UndoManager.redo();
            // sender.set("active", 0);
          }
        },
        attributes: {
          title: "Redo (CTRL/CMD + Y)",
        },
      },
    ]);

    panelManager.addPanel({
      id: "myNewPanel",
      buttons: [
        {
          id: "logo",
          className: "logo-editor",
          label: `<img src="https://thumbs.${process.env.REACT_APP_MAIN_DOMAIN}/images/pixapage-logot.png" alt="Logo" height="40">`,
        },
        {
          id: "backbtn",
          disabled: isLoading,
          command: {
            run: () => {
              setOpenConfirmationClose(true);
            },
          },
          className: " btnBack",
          label: `<button   class="ccc btn btn-secondary Mydropdowntoogle" style="color:#333;background-color: #FFF;cursor:pointer"> 
          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
     <span class="px-2 fw-semibold"> ${draftLoading ? "loading" : "Close"}  <span>                
      </span> </span>
       </button>
  `,
        },
        {
          id: "savebtn",
          disabled: isLoading,
          command: {
            run: async () => {
              setSavingOpen(true);
            },
          },
          className: "fa-solid fa-floppy-disk",
          label: `<button   class="ccc btn btn-secondary Mydropdowntoogle" style="background-color: green;cursor:pointer"> 
                    <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M840-680v480q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160Zm-80 34L646-760H200v560h560v-446ZM480-240q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM240-560h360v-160H240v160Zm-40-86v446-560 114Z"/></svg>
               <span class="px-2 fw-semibold"> ${
                 draftLoading ? "loading" : "Save"
               }  <span>                
                </span> </span>
                 </button>
            `,
        },
        {
          id: "cmdDeviceDesktop",
          command: (e) => e.setDevice("Desktop"),
          className: "fa fa-desktop",
          active: 1,
        },
        {
          id: "cmdDeviceTablet",
          command: (e) => e.setDevice("Tablet"),
          className: "fa fa-tablet",
        },
        {
          id: "cmdDeviceMobile",
          command: (e) => e.setDevice("Mobile portrait"),
          className: "fa fa-mobile",
        },
        {
          id: "PageName",
          label: pageTitle,
          active: 1,
        },
      ],
    });

    sidebarPannel({ editor, settingSidebarOpen, setSettingSidebarOpen });
    // seoPannel({ editor, page, toast, setUpdateGrapeJs, updateGrapeJs });
    grapeJsEvents(editor);
    utils(editor);
    alignment(editor);
    replaceTextViewComponent(editor);

    const importScss = async () => {
      const scssModule = await import("../pages/grapejs_v1.scss");
      //  console.log(scssModule);
      return scssModule.default;
    };

    let linkTag;
    importScss().then((scssHref) => {
      // Create a new <link> tag
      //console.log(scssHref);
      linkTag = document.createElement("link");
      linkTag.rel = "stylesheet";
      linkTag.href = scssHref; //`http://${process.env.REACT_APP_MAIN_DOMAIN}/grapejs_v1.scss`;
      document.head.appendChild(linkTag);
    });

    // Cleanup function to unload CSS when the component unmounts
    return () => {
      if (linkTag) {
        document.head.removeChild(linkTag);
      }
    };
  };

  const closePage = () => {
    setOpenPageTitle(false);
    setIsLoading(false);
    setSavingOpen(false);
  };

  const verifiNextPage = () => {
    if (grapeEditor) {
      const html = grapeEditor.getHtml();
      if (!html.includes("[NEXT_PAGE]"))
        return "A 'Next Page' button was not detected. Please add a 'Next Page' button from the form widgets to connect to the next page. If this is the last page in your funnel, you can ignore this message";
      else return "";
    } else return "";
  };

  const renderSnackBar = (
    <MDSnackbar
      color="success"
      icon="save"
      title="Setting saved"
      dateTime=""
      open={openSettingSaved}
      onClose={closeSettingSaved}
      close={closeSettingSaved}
      backgroundcolor={"error"}
    />
  );

  return (
    <>
      <ConfirmationAlert
        openModal={openConfirmationClose}
        isLoading={isLoading}
        title={
          <MDBox>
            <MDBox>
              Are you sure you want to close the page? Any unsaved changes will be lost.
            </MDBox>
            <MDBox>
              <MDTypography variant="body2">{verifiNextPage()}</MDTypography>{" "}
            </MDBox>
          </MDBox>
        }
        onClose={() => setOpenConfirmationClose(false)}
      />
      <Dialog
        open={openPageTitle}
        onClose={(e, reason) => reason != "backdropClick" ?? closePage()}
      >
        <MDBox
          variant="gradient"
          bgColor="secondary"
          coloredShadow="secondary"
          mt={-1}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h6" fontWeight="medium" color="white" mt={1}>
            Page name
          </MDTypography>
        </MDBox>
        <DialogContent>
          <MDInput
            disabled={isLoading}
            style={{ padding: 10 }}
            type="text"
            label="Page name"
            fullWidth
            value={pageTitle}
            onChange={(e) => setPageTitle(e.target.value)}
            required
          />
          <MDBox color="red">
            {simpleValidator.current.message("Page Title", pageTitle, "required")}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            disabled={isLoading}
            onClick={() => closePage()}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </MDButton>
          <MDButton
            disabled={isLoading}
            onClick={() => {
              addNewPage();
            }}
            color="success"
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={savingOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogContent>
          <MDBox textAlign="center" style={{ backgroundcolor: "#FFF" }}>
            {isSaving && (
              <MDBox textAlign="center">
                <CircularProgress size={60} color="info" margin="10" mb="5" />
                <MDTypography> Saving ...</MDTypography>
              </MDBox>
            )}
            {loadingText != "" && (
              <MDBox>
                <MDTypography variant="h6" fontWeight="medium" color="info">
                  {loadingText}
                </MDTypography>
              </MDBox>
            )}
          </MDBox>

          {showClose && (
            <MDBox textAlign="right" style={{ backgroundcolor: "#FFF" }} mt="5">
              <MDButton
                onClick={() => {
                  setSavingOpen(false);
                  setShowClose(false);
                }}
                color="secondary"
              >
                Close
              </MDButton>
            </MDBox>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={isLoading}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogContent>
          <MDBox textAlign="center" style={{ backgroundcolor: "#FFF" }}>
            {isLoading && <CircularProgress size={60} color="info" margin="10" />}
            {loadingText != "" && (
              <MDBox>
                <MDTypography variant="h6" fontWeight="medium" color="info">
                  Loading ...
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
      </Dialog>
      {settingSidebarOpen && (
        <Settingsidebar
          isLoading={isLoading}
          editor={grapeEditor}
          setSettingSidebarOpen={setSettingSidebarOpen}
          initialData={selectedPage}
          updatePageSettings={(seoTitle, seoKeyword, seoDescription, seoSlug) =>
            updateSettings(seoTitle, seoKeyword, seoDescription, seoSlug)
          }
          updatePageScripts={(
            googleConversionId,
            conversionLabel,
            googleMetaTag,
            googleAnalyticsId,
            msSiteVerificationTag,
            msUetTagId,
            headScript,
            bodyScript,
            footerScript
          ) =>
            updateScript(
              googleConversionId,
              conversionLabel,
              googleMetaTag,
              googleAnalyticsId,
              msSiteVerificationTag,
              msUetTagId,
              headScript,
              bodyScript,
              footerScript
            )
          }
          updateFavicon={(url) => {
            setFaviconUrl(url);
          }}
          updateBgImage={(url) => {
            setBgImageUrl(url);
          }}
        />
      )}
      <div id="gjs" style={{ position: "absolute", zIndex: 100, left: 0, top: 0 }}></div>
      {renderSnackBar}
    </>
  );
}

export default Grape;

/*

      <Card style={{ padding: 10, height: "100%", backgroundColor: "#00044d" }}>
       
        <Grid container justifyContent="center" sx={{ my: 1 }}>
          <Grid item xs={12} lg={12} style={{ width: "100%", height: "100%" }}></Grid>
        </Grid>
      </Card>
      */
